'use strict';

angular.module('imagetrend.components')
    .controller('hlpSsnController', ['$scope', '$timeout', 'Format', 'Validation', 'Logger', function ($scope, $timeout, Format, Validation, Logger) {

        var validationTimeout = $timeout(function () {
            if (!$scope.requiredText) { $scope.requiredText = 'Please enter a ' + Format.label(($scope.label || $scope.name)) }

            if ($scope.vm.showSSN && $scope.recordId && !($scope.ngModel == null || $scope.ngModel == '')) {
                Logger.logAccess($scope.recordId, "Social Security Number");
            }

            $scope.validate = function() {
                if ($scope.question !== undefined && $scope.question.answer !== undefined) {
                    $scope.question.answer.invalid = !isEmpty($scope.innerForm.ssn.$error);
                }
                if ($scope.validation) {
                    Validation.validateQuestion($scope.innerForm.ssn, $scope.validation, $scope.ngModel).then(function (result) {
                        if ($scope.question !== undefined && $scope.question.answer !== undefined) {
                            $scope.question.answer.invalid = !result || !isEmpty($scope.innerForm.ssn.$error) || !isEmpty($scope.innerForm.$error);
                        }
                    });
                }
            }

            if ($scope.innerForm !== undefined) {
                if ($scope.isRequired && ($scope.ngModel == null || $scope.ngModel == '') && !$scope.innerForm.ssn.$error.phone) {
                    $scope.innerForm.ssn.$setValidity("required", false);
                }
                else {
                    $scope.innerForm.ssn.$setValidity("required", true);
                }
                $scope.validate();
            }
        }, 0);
        $scope.$on('$destroy', function () {
            $timeout.cancel(validationTimeout);
        });

        var isNumeric = function (n) {
            return !isNaN(parseFloat(n)) && isFinite(n);
        }
        
        $scope.setSsn = function (boxone, boxtwo, boxthree) {
            $scope.innerForm.ssn.$setDirty();

            if (isUndefined(boxone) || isUndefined(boxtwo) || isUndefined(boxthree)) {
                $scope.ngModel = '';
                if (isUndefined(boxone) && isUndefined(boxtwo) && isUndefined(boxthree)) {
                    $scope.innerForm.ssn.$setValidity("ssn", true);
                }
                else {
                    $scope.innerForm.ssn.$setValidity("ssn", false);
                }
                if (!isUndefined(boxone) && boxone.length == 3 && isUndefined(boxtwo)) {
                    $scope.$broadcast('focustwo');
                }
                if (!isUndefined(boxtwo) && boxtwo.length == 2 && isUndefined(boxthree)) {
                    $scope.$broadcast('focusthree');
                }
            }
            else {
                if (boxone.length == 3 && (isNumeric(boxone) || boxone == "\u2022\u2022\u2022") && boxtwo.length == 2 && (isNumeric(boxtwo) || boxtwo == "\u2022\u2022") && boxthree.length == 4 && isNumeric(boxthree)) {
                    $scope.ngModel = boxone + "-" + boxtwo + "-" + boxthree;
                    $scope.innerForm.ssn.$setValidity("ssn", true);
                }
                else {
                    $scope.ngModel = '';
                    $scope.innerForm.ssn.$setValidity("ssn", false);
                }
            }

            if ($scope.isRequired && ($scope.ngModel == null || $scope.ngModel == '') && !$scope.innerForm.ssn.$error.ssn) {
                $scope.innerForm.ssn.$setValidity("required", false);
            }
            else {
                $scope.innerForm.ssn.$setValidity("required", true);
            }

            $scope.onChange($scope.ngModel);
        }

        $scope.getSectionType = function (boxNumber) {
            var result = "password";
            // security is the ssn_settings value. 0 = masked, 1 = last 4 shown, 2 = all shown
            switch(boxNumber) {
                case 1:
                    result = ($scope.security == 2 || $scope.vm.showSSN) ? "text" : "password";
                    break;
                case 2:
                    result = ($scope.security == 2 || $scope.vm.showSSN) ? "text" : "password";
                    break;
                case 3:
                    result = ($scope.security >= 1 || $scope.vm.showSSN) ? "text" : "password";
                    break;
            }
            return result;
        }

        $scope.setFields = function (value) {
            var valueList = value.split('-');
            if (value != undefined && value.split('-').length == 3) {
                $scope.vm.boxone = valueList[0];
                $scope.vm.boxtwo = valueList[1];
                $scope.vm.boxthree = valueList[2];
            }
            else if (value != undefined && value.indexOf("-") < 0 && value.length == 9) {
                $scope.vm.boxone = value.substring(0,3);
                $scope.vm.boxtwo = value.substring(3, 5);
                $scope.vm.boxthree = value.substring(5, 9);
            }
        };

        $scope.$watch('ngModel', function (ngModel) {
            if (!isUndefined(ngModel) && isUndefined($scope.vm.boxone) && isUndefined($scope.vm.boxtwo) && isUndefined($scope.vm.boxthree)) {
                $scope.setFields(ngModel);
            }
        });
    }])
    .directive('hlpSsn', ['Format', '$timeout', 'Validation', 'Logger', function (Format, $timeout, Validation, Logger) {
        return {
            restrict: 'AE',
            scope: {
                name: '@',
                id: '@?',
                showLabel: '@?',
                topLabel: '=?',
                showColon: '=?',
                isRequired: '=?',
                showRequired: '=?',
                isDisabled: '=?',
                change: '&?',
                ngModel: '=',
                question: '=?',
                recordId: '=?',
                label: '@?',
                title: '@?',
                requiredText: '@?',
                instructions: '@?',
                classes: '@?',
                security: '@?',
                pdf: '=?',
                validation: '=?',
                isGenerated: '=?'
            },
            replace: true,
            require: 'ngModel',
            templateUrl: 'templates/ssn/ssn.html',
            link: function (scope, elem, attrs, ctrl) {

                scope.timeouts = [];

                if (!attrs.id) { attrs.id = attrs.name; }
                if (!attrs.label) { attrs.label = Format.label(attrs.name); }
                if (!attrs.showLabel) { attrs.showLabel = attrs.label.length > 0; } else { if (attrs.showLabel == 'true') { attrs.showLabel = true; } else { attrs.showLabel = false; } }
                if (!attrs.topLabel) { attrs.topLabel = false; } else { if (attrs.topLabel == true || attrs.topLabel == 'true') { attrs.topLabel = true; } else { attrs.topLabel = false; } }
                if (!attrs.showColon) { attrs.showColon = true; } else { if (attrs.showColon == true || attrs.showColon == 'true') { attrs.showColon = true; } else { attrs.showColon = false; } }
                //if (!attrs.isRequired) { attrs.isRequired = false; } else { if (attrs.isRequired == 'true') { attrs.isRequired = true; } else { attrs.isRequired = false; } }
                if (!attrs.title) { attrs.title = attrs.label; }
                if (!attrs.security) { attrs.security = 0 }
                scope.vm = {};
                scope.vm.showSSN = scope.security == 2;
                scope.vm.boxone = "";
                scope.vm.boxtwo = "";
                scope.vm.boxthree = "";

                scope.onChange = function (item) {
                    scope.submitted = false;
                    ctrl.$setViewValue(item);
                    if (scope.question !== undefined && scope.question.answer !== undefined) {
                        scope.question.answer.invalid = !isEmpty(scope.innerForm.ssn.$error);
                    }
                    if (scope.validation) {
                        Validation.validateQuestion(scope.innerForm.ssn, scope.validation, scope.ngModel).then(function (result) {
                            if (scope.question !== undefined && scope.question.answer !== undefined) {
                                scope.question.answer.invalid = !result || !isEmpty(scope.innerForm.ssn.$error) || !isEmpty(scope.innerForm.$error);
                            }
                        });
                    }
                }
                scope.log = function () {
                    if (scope.vm.showSSN && scope.recordId && !(scope.ngModel == null || scope.ngModel == '')) {
                        Logger.logAccess(scope.recordId, "Social Security Number");
                    }
                }
                scope.submitted = false;
                scope.$on('form:submit', function () {
                    scope.validate();
                    scope.submitted = true;
                });

                scope.$on('$destroy', function () {
                    scope.timeouts.forEach(function (timer) {
                        $timeout.cancel(timer);
                    });
                });
            },
            controller: 'hlpSsnController'
        };
    }])
;